import React from 'react';
import PropTypes from 'prop-types';

import { Trans, useTranslation } from 'react-i18next';
import Styles from '../../../styles/minisite/minisite.module.css';
import '../../../styles/minisite/main.scss';
import { ColorPickerLabel, Form, Select, Icon } from '@weezevent/nacre';
//import UploadImageZoneGemino from './upload/uploadImageZoneGemino';

const COLORS = [
    '#e7fbff',
    '#cff7ff',
    '#b3f2ff',
    '#95edff',
    '#78e9ff',
    '#9ab4ff',
    '#84a1ff',
    '#6689ff',
    '#3e67ff',
    '#0030f5',
    '#8fc67d',
    '#5fa666',
    '#728c57',
    '#759833',
    '#3b8442',
    '#e06ee0',
    '#ba4ddb',
    '#8d209b',
    '#7d29c6',
    '#4f176c',
    '#fffd8d',
    '#fdfa72',
    '#ffdd3c',
    '#ffd400',
    '#ffb733',
    '#f9f9d9',
    '#ffa112',
    '#ff9e1b',
    '#ff8700',
    '#e0610e',
    '#f4bebe',
    '#e38c8c',
    '#df6464',
    '#df4242',
    '#dd0909',
    '#ffe4bf',
    '#e4bf80',
    '#bf8040',
    '#804015',
    '#401500',
    '#bdbdbd',
    '#6f6b6b',
    '#4b4949',
    '#201d1d',
    '#000000'
];

const fonts = [
    {
        value: 'Dejavu Sans, Arial, Verdana, sans-serif',
        text: 'Dejavu Sans',
        style: { fontFamily: 'Dejavu Sans, Arial, Verdana, sans-serif' }
    },
    {
        value: 'Bodoni MT',
        text: 'Bodoni MT',
        style: { fontFamily: 'Bodoni MT' }
    },
    {
        value: 'Franklin Gothic',
        text: 'Franklin Gothic',
        style: { fontFamily: 'Franklin Gothic' }
    },
    {
        value: 'Times',
        text: 'Times',
        style: { fontFamily: 'Times' }
    },
    {
        value: 'Arial Black',
        text: 'Arial Black',
        style: { fontFamily: 'Arial Black' }
    },
    {
        value: 'Courier New, Courier, Lucida Sans Typewriter, Lucida Typewriter, monospace',
        text: 'Courier New',
        style: { fontFamily: 'Courier New, Courier, Lucida Sans Typewriter, Lucida Typewriter, monospace' }
    },
    {
        value: 'Arial',
        text: 'Arial',
        style: { fontFamily: 'Arial' }
    },
    {
        value: 'Helvetica Neue, Helvetica, Arial, sans-serif',
        text: 'Helvetica Neue',
        style: { fontFamily: 'Helvetica Neue, Helvetica, Arial, sans-serif' }
    },
    {
        value: 'Verdana',
        text: 'Verdana',
        style: { fontFamily: 'Verdana' }
    },
    {
        value: 'Graphik',
        text: 'Graphik',
        style: { fontFamily: 'Graphik' }
    }
];

export default function ColorsOptions({ formMinisite, handleChange }) {
    const { t } = useTranslation();

    const changeFont = React.useCallback(
        value => {
            handleChange('font_family', value);
        },
        [handleChange]
    );

    const changePrimaryColor = React.useCallback(
        (ev, value) => {
            handleChange('primary_color', value);
        },
        [handleChange]
    );

    const changeBlockColor = React.useCallback(
        (ev, value) => {
            handleChange('light_primary_color', value);
        },
        [handleChange]
    );

    const changeBackgroundColor = React.useCallback(
        (ev, value) => {
            handleChange('background_color', value);
        },
        [handleChange]
    );
    /*
    const setBannerUrl = React.useCallback(
        href => {
            handleChange('url', href);
        },
        [handleChange]
    );

    const removeBannerUrl = React.useCallback(() => {
        handleDelete('url');
    }, [handleDelete]);*/

    return (
        <Form>
            <div className={Styles['options-subtitle']}>
                <Trans i18nKey="ticket.event.minisite.colors_options.title" />
            </div>
            <Form.Field className={Styles['options-color']}>
                <ColorPickerLabel
                    label={t('ticket.event.minisite.colors_options.principal_color')}
                    onChange={changePrimaryColor}
                    value={formMinisite['primary_color']}
                    colors={COLORS}
                />
            </Form.Field>
            <Form.Field className={Styles['options-color']}>
                <ColorPickerLabel
                    label={t('ticket.event.minisite.colors_options.light_principal_color')}
                    onChange={changeBlockColor}
                    value={formMinisite['light_primary_color']}
                    colors={COLORS}
                />
            </Form.Field>
            <Form.Field className={Styles['options-color']}>
                <ColorPickerLabel
                    label={t('ticket.event.minisite.colors_options.background_color')}
                    onChange={changeBackgroundColor}
                    value={formMinisite['background_color']}
                    colors={COLORS}
                />
            </Form.Field>
            <div
                className={Styles['reset']}
                onClick={() => handleChange('reset_colors', { primary_color: '#0032FA', light_primary_color: '#F5F5F5', background_color: '#F5F5F5' })}
            >
                <Icon name="Reset" />
                <span>{t('ticket.common.action.reset')}</span>
            </div>

            {/*<Form.Field>
                <div className={Styles['options-title']}>
                    <Trans i18nKey="ticket.event.minisite.colors_options.background_img" />
                </div>
                <UploadImageZoneGemino
                    organization={organization}
                    onUpload={setBannerUrl}
                    icon={'picture'}
                    textInfo={t('ticket.event.minisite.colors_options.dropzone_banner')}
                    images={formMinisite.url || []}
                    onDelete={removeBannerUrl}
                />
            </Form.Field>*/}

            <Form.Field>
                <div className={Styles['options-title']}>
                    <Trans i18nKey="ticket.event.minisite.colors_options.font" />
                </div>
                <Select options={fonts} onChange={changeFont} value={formMinisite['font_family']} />
            </Form.Field>
        </Form>
    );
}

ColorsOptions.propTypes = {
    formMinisite: PropTypes.array.isRequired,
    handleChange: PropTypes.func.isRequired
};
